import { useEffect, useRef, useState } from 'react';
import API from '../api';

// ── AI 어시스턴트 (로컬 LLM 기반 분석/리포트/챗봇) ──────────────────────────
// 2026-08 요청: "완전히 로컬로 적용되고 제한없이 무료로 사용할 수 있는 AI 기능" 11종을
// 순차 구현. 이 화면 하나에 모든 AI 기능을 카드 형태로 모아둔다(각 메뉴에 흩어놓지 않고,
// 여기서 대상 메뉴를 골라 분석을 실행하는 방식 — 기존 메뉴 화면들을 건드리지 않고 독립적으로
// 추가/확장하기 위함). 11개 기능 모두 이번 차수로 구현 완료.
//
// 실제 동작을 위해서는 이 서버 컴퓨터(C:\ims)에 Ollama가 설치되어 있어야 한다(무료, 완전
// 오프라인 동작). 설치 전에는 아래 상태 배지가 "연결 안 됨"으로 표시되고, 분석 실행 시 안내
// 메시지가 뜬다 — backend/utils/aiClient.js 상단 주석에 설치 방법이 자세히 적혀 있다.

// 2026-08 개편: "AI 어시스턴트" → "경영분석"으로 메뉴 개편하면서, 버튼 구성을 5개 그룹(각
// 4개)으로 재정리했다. OCR 자동입력/AI 챗봇은 이번 개편 대상 버튼 목록에 포함되지 않아 그리드
// 에서는 뺐다(내부 로직/라우트는 그대로 남아 있어 필요하면 나중에 다시 노출할 수 있다).
const FEATURE_GROUPS = [
  [
    { key: 'tasks_delay', label: '업무지연 및 문제점 분석', desc: '업무관리에 등록된 업무 중 지연·임박 건을 분석해 원인과 해결방안을 제시합니다.' },
    { key: 'weekly_report', label: '주간회의 종합리포트', desc: '완료/진행중/지연/문제 현황을 종합한 주간회의용 리포트를 생성합니다.' },
    { key: 'weekly_accounting', label: '주간회계 종합리포트', desc: '계약/급여 현황을 바탕으로 한 주간 회계 리포트를 생성합니다(별도 회계원장 대신 계약·급여 데이터를 사용).' },
    { key: 'weekly_hr', label: '주간인사 종합리포트', desc: '근태/휴가/발령/평가 현황을 종합한 주간 인사 리포트를 생성합니다.' },
  ],
  [
    { key: 'social_analysis', label: '소셜 마케팅 분석', desc: '채널별 소셜 게시 현황을 바탕으로 문제점을 분석하고 개선안을 제시합니다.' },
    { key: 'sales_analysis', label: '영업활동 분석 및 제안', desc: '영업활동의 문제점을 분석하고 개선방안을 제시합니다.' },
    { key: 'sales_report', label: '영업활동 종합 보고서', desc: '영업활동율을 분석한 종합 보고서를 생성합니다.' },
    { key: 'companies_analysis', label: '등록업체 종합분석 보고서', desc: '등록된 고객사/협력사 현황과 등록정보 완비도를 분석합니다.' },
  ],
  [
    { key: 'production_analysis', label: '생산 진행현황 분석', desc: '생산현황 지연 데이터를 분석합니다.' },
    { key: 'shipment_analysis', label: '출고 및 대상분석', desc: '출고 보류 현황과 거래처(대상)별 출고 동향을 분석합니다.' },
    { key: 'inventory_analysis', label: '재고현황 분석', desc: '부품 재고 부족 후보와 최근 불량 발생 동향을 분석합니다.' },
    { key: 'ops_analysis', label: '생산,출고,재고현황 종합분석', desc: '생산·출고·재고를 한 번에 종합 분석합니다.' },
  ],
  [
    { key: 'task_progress', label: '업무 진행능력 분석', desc: '직원별 업무 처리 속도와 완료율을 분석합니다.' },
    { key: 'task_difficulty', label: '업무 난이도 분석', desc: '직원별 업무 난이도/복잡도를 분석합니다.' },
    { key: 'employee_eval', label: '직원 종합평가', desc: '업무·근태 등록 현황을 종합 분석해 직원평가 초안을 만들어줍니다.' },
    { key: 'department_eval', label: '부서 종합평가', desc: '부서 소속 직원들의 업무/근태를 종합해 부서 단위 평가를 생성합니다.' },
  ],
  [
    { key: 'overall_all', label: '종합경영보고서(통합)', desc: '업무·영업·생산·인증·회계·인사 전 영역을 아우르는 종합 보고서입니다.' },
    { key: 'overall_accounting', label: '종합경영보고서(회계)', desc: '계약/급여 지표 중심의 종합 보고서입니다.' },
    { key: 'overall_hr', label: '종합경영보고서(인사)', desc: '근태/휴가/평가 지표 중심의 종합 보고서입니다.' },
    { key: 'overall_ops', label: '종합경영보고서(업무)', desc: '업무·영업·생산·출고·인증 지표 중심의 종합 보고서입니다.' },
  ],
  // 2026-09(21차) 요청 — 자산관리/영업관리 화면 안의 개별 AI리포트 버튼을 삭제하면서,
  // 그 자리를 대신할 종합리포트 3종을 경영분석(여기)에 새로 추가한다. 자산관리는 기존
  // /ai/analyze/assets 라우트를 그대로 재사용하고, 회계관리는 실제 회계 원장(acct_*
  // 테이블) 기반의 신규 라우트, 원가관리는 IMS에 별도 원가관리 메뉴가 없으므로 재고관리의
  // 원자재 발주단가 + 생산관리의 생산수량/제품군 데이터를 조합한 추정 분석 신규 라우트를 쓴다
  // (계약/급여를 회계 대리지표로 쓰는 기존 weekly_accounting/overall_accounting과 같은 방식).
  [
    { key: 'assets_analysis', label: '자산관리 종합리포트', desc: '자산 상태별 분포, 감가상각 커버리지, 폐기자산, 수리/대여 장기 미처리, 재물조사 불일치를 종합 분석합니다.' },
    { key: 'accounting_analysis', label: '회계관리 종합리포트', desc: '매출/매입/전표/은행거래 등 실제 회계 원장 데이터를 바탕으로 손익·자금 현황을 종합 분석합니다.' },
    { key: 'cost_analysis', label: '원가관리 종합리포트', desc: '별도 원가관리 데이터가 없어 재고관리의 원자재 발주단가와 생산관리의 생산수량/제품군 데이터를 조합해 제품별 원가를 추정 분석합니다.' },
  ],
];
const FEATURES = FEATURE_GROUPS.flat();

// 2026-09(21차) 요청 — "보기편하게 구분"을 위해 6개 그룹 각각에 제목/설명/강조색을 부여하고
// (기존에는 4개씩 묶인 카드 그리드만 있고 그룹 구분이 전혀 표시되지 않았음), 카드는 소속 그룹의
// 강조색을 좌측 라인 + 선택 시 테두리 색으로 사용해 한눈에 "어느 묶음"인지 구분되게 한다.
// FEATURE_GROUPS와 배열 인덱스가 1:1로 대응한다.
const GROUP_META = [
  { icon: '📅', title: '주간 리포트', desc: '업무·회계·인사 현황을 매주 확인하는 정기 리포트', color: '#2563EB', bg: '#EFF6FF' },
  { icon: '📈', title: '영업·마케팅', desc: '영업활동, 소셜 채널, 등록업체 현황 분석', color: '#9333EA', bg: '#FAF5FF' },
  { icon: '🏭', title: '생산·출고·재고', desc: '생산 지연, 출고 보류, 재고 부족 등 현장 데이터 분석', color: '#EA580C', bg: '#FFF7ED' },
  { icon: '👤', title: '직원·부서 평가', desc: '업무 처리 속도/난이도, 직원·부서 단위 종합평가', color: '#059669', bg: '#ECFDF5' },
  { icon: '🗂️', title: '종합경영보고서', desc: '여러 영역을 한 번에 아우르는 통합/영역별 보고서', color: '#4338CA', bg: '#EEF2FF' },
  { icon: '✨', title: '자산·회계·원가', desc: '자산관리·회계관리 화면의 개별 AI리포트를 대신하는 종합리포트', color: '#0D9488', bg: '#F0FDFA' },
];

const cardStyle = {
  border: '1px solid #e5e7eb', borderRadius: 10, padding: '14px 16px', background: '#fff',
  display: 'flex', flexDirection: 'column', gap: 8, minHeight: 96, cursor: 'pointer',
  borderLeftWidth: 3,
};
const panelStyle = { border: '1px solid #e5e7eb', borderRadius: 10, padding: 20, background: '#fff' };
const btnStyle = (disabled) => ({
  padding: '8px 16px', borderRadius: 6, border: 'none', cursor: disabled ? 'default' : 'pointer',
  background: disabled ? '#93C5FD' : '#2563EB', color: '#fff', fontSize: 13, fontWeight: 600,
});
const reportBoxStyle = { whiteSpace: 'pre-wrap', lineHeight: 1.7, fontSize: 14, color: '#1f2937', background: '#F9FAFB', border: '1px solid #eee', borderRadius: 8, padding: 16 };

export default function AiAssistant() {
  const [status, setStatus] = useState(null);
  const [statusLoading, setStatusLoading] = useState(true);
  const [active, setActive] = useState('tasks_delay');

  const loadStatus = () => {
    setStatusLoading(true);
    API.get('/ai/status').then(r => setStatus(r.data)).catch(() => setStatus({ online: false })).finally(() => setStatusLoading(false));
  };
  useEffect(() => { loadStatus(); }, []);

  return (
    <div style={{ padding: 24, maxWidth: 1000, margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
        <div>
          <h2 style={{ margin: 0, fontSize: 22 }}>📊 경영분석</h2>
          <div style={{ color: '#888', fontSize: 13, marginTop: 4 }}>
            서버 컴퓨터에 설치된 로컬 AI로만 작동합니다.
          </div>
        </div>
        {!statusLoading && (
          <div style={{
            padding: '6px 14px', borderRadius: 20, fontSize: 13, fontWeight: 600,
            background: status?.online ? '#ECFDF5' : '#FEF2F2',
            color: status?.online ? '#059669' : '#DC2626',
            display: 'flex', alignItems: 'center', gap: 6,
          }}>
            <span style={{ width: 8, height: 8, borderRadius: '50%', background: status?.online ? '#059669' : '#DC2626', display: 'inline-block' }} />
            {status?.online ? 'AI 연결됨' : 'AI 연결 안 됨'}
            <button onClick={loadStatus} style={{ marginLeft: 6, border: 'none', background: 'none', cursor: 'pointer', color: 'inherit', textDecoration: 'underline' }}>
              새로고침
            </button>
          </div>
        )}
      </div>

      {/* 2026-08 요청: "Ollama 미설치/미실행" 안내 배너는 항상 숨김 처리(사용자 요청) —
          Ollama 연결 안내는 상단 "AI 연결 안 됨" 배지로만 표시하고, 이 아래 설치 안내
          박스는 더 이상 노출하지 않는다. 조건을 false로 고정해 로직/문구는 그대로 남겨둔다. */}
      {false && !statusLoading && !status?.online && (
        <div style={{ background: '#FFFBEB', border: '1px solid #FDE68A', borderRadius: 8, padding: 14, marginBottom: 16, fontSize: 13, color: '#92400E', lineHeight: 1.6 }}>
          이 서버 컴퓨터에 Ollama가 설치되어 있지 않거나 실행 중이 아닙니다. AI 기능을 쓰려면
          <b> https://ollama.com/download</b> 에서 설치 후, 명령 프롬프트에서
          <code style={{ background: '#fff', padding: '1px 5px', borderRadius: 4, margin: '0 3px' }}>ollama pull qwen3:8b</code>
          와
          <code style={{ background: '#fff', padding: '1px 5px', borderRadius: 4, margin: '0 3px' }}>ollama pull qwen3:14b</code>
          를 실행해주세요. 설치 후에는 IMS 서버 재시작 없이 바로 사용할 수 있습니다.
        </div>
      )}
      {!statusLoading && status?.online && (status?.fastModelReady === false || status?.deepModelReady === false) && (
        <div style={{ background: '#FFFBEB', border: '1px solid #FDE68A', borderRadius: 8, padding: 14, marginBottom: 16, fontSize: 13, color: '#92400E' }}>
          Ollama는 연결되었지만 필요한 모델이 아직 없습니다. 명령 프롬프트에서
          {status?.fastModelReady === false && <code style={{ background: '#fff', padding: '1px 5px', borderRadius: 4, margin: '0 3px' }}>ollama pull qwen3:8b</code>}
          {status?.deepModelReady === false && <code style={{ background: '#fff', padding: '1px 5px', borderRadius: 4, margin: '0 3px' }}>ollama pull qwen3:14b</code>}
          를 실행해주세요.
        </div>
      )}

      {FEATURE_GROUPS.map((group, gi) => {
        const meta = GROUP_META[gi] || { icon: '📁', title: '', desc: '', color: '#2563EB' };
        return (
          <div key={gi} style={{ marginBottom: gi === FEATURE_GROUPS.length - 1 ? 8 : 22 }}>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 10, paddingLeft: 2 }}>
              <span style={{
                display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 14, fontWeight: 700, color: meta.color,
              }}>
                <span aria-hidden="true">{meta.icon}</span>{meta.title}
                {meta.badge && (
                  <span style={{ background: meta.color, color: '#fff', fontSize: 10, fontWeight: 700, borderRadius: 10, padding: '2px 7px' }}>{meta.badge}</span>
                )}
              </span>
              <span style={{ fontSize: 12, color: '#9CA3AF' }}>{meta.desc}</span>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 12 }}>
              {group.map(f => {
                const isActive = active === f.key;
                return (
                  <div
                    key={f.key}
                    onClick={() => setActive(f.key)}
                    style={{
                      ...cardStyle,
                      borderLeftColor: meta.color,
                      borderColor: isActive ? meta.color : '#e5e7eb',
                      background: isActive ? meta.bg : '#fff',
                      boxShadow: isActive ? `0 0 0 2px ${meta.color}26` : 'none',
                    }}
                  >
                    <div style={{ fontWeight: 700, fontSize: 14 }}>{f.label}</div>
                    <div style={{ fontSize: 12, color: '#6B7280', lineHeight: 1.5 }}>{f.desc}</div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}

      {active === 'tasks_delay' && <TaskDelayPanel />}
      {active === 'weekly_report' && <WeeklyReportPanel />}
      {active === 'weekly_accounting' && <SimpleReportPanel title="💰 주간회계 종합리포트" endpoint="/ai/reports/weekly-accounting/generate" reportType="weekly_accounting" />}
      {active === 'weekly_hr' && <SimpleReportPanel title="🧑‍💼 주간인사 종합리포트" endpoint="/ai/reports/weekly-hr/generate" reportType="weekly_hr" />}
      {active === 'social_analysis' && <SimpleReportPanel title="📱 소셜 마케팅 분석" endpoint="/ai/analyze/social" reportType="social" />}
      {active === 'sales_analysis' && <SalesPanel focus="problem" title="📉 영업활동 분석 및 제안" />}
      {active === 'sales_report' && <SalesPanel focus="report" title="📊 영업활동 종합 보고서" />}
      {active === 'companies_analysis' && <SimpleReportPanel title="🏢 등록업체 종합분석 보고서" endpoint="/ai/analyze/companies" reportType="companies" />}
      {active === 'production_analysis' && <SimpleReportPanel title="🏭 생산 진행현황 분석" endpoint="/ai/analyze/ops" reportType="ops_production" body={{ scope: 'production' }} />}
      {active === 'shipment_analysis' && <SimpleReportPanel title="🚚 출고 및 대상분석" endpoint="/ai/analyze/ops" reportType="ops_shipment" body={{ scope: 'shipment' }} />}
      {active === 'inventory_analysis' && <SimpleReportPanel title="📦 재고현황 분석" endpoint="/ai/analyze/ops" reportType="ops_inventory" body={{ scope: 'inventory' }} />}
      {active === 'ops_analysis' && <SimpleReportPanel title="🏭 생산,출고,재고현황 종합분석" endpoint="/ai/analyze/ops" reportType="ops" body={{ scope: 'all' }} />}
      {active === 'task_progress' && <EmployeePanel focus="progress" title="📈 업무 진행능력 분석" />}
      {active === 'task_difficulty' && <EmployeePanel focus="difficulty" title="📐 업무 난이도 분석" />}
      {active === 'employee_eval' && <EmployeePanel focus="evaluation" title="👤 직원 종합평가" />}
      {active === 'department_eval' && <DepartmentPanel title="🏬 부서 종합평가" />}
      {active === 'overall_all' && <SimpleReportPanel title="🗂 종합경영보고서(통합)" endpoint="/ai/analyze/overall" reportType="overall_all" body={{ scope: 'all' }} />}
      {active === 'overall_accounting' && <SimpleReportPanel title="💰 종합경영보고서(회계)" endpoint="/ai/analyze/overall" reportType="overall_accounting" body={{ scope: 'accounting' }} />}
      {active === 'overall_hr' && <SimpleReportPanel title="🧑‍💼 종합경영보고서(인사)" endpoint="/ai/analyze/overall" reportType="overall_hr" body={{ scope: 'hr' }} />}
      {active === 'overall_ops' && <SimpleReportPanel title="🗂 종합경영보고서(업무)" endpoint="/ai/analyze/overall" reportType="overall_ops" body={{ scope: 'ops' }} />}
      {active === 'assets_analysis' && <SimpleReportPanel title="🗃 자산관리 종합리포트" endpoint="/ai/analyze/assets" reportType="assets" />}
      {active === 'accounting_analysis' && <SimpleReportPanel title="💳 회계관리 종합리포트" endpoint="/ai/analyze/accounting" reportType="accounting" />}
      {active === 'cost_analysis' && <SimpleReportPanel title="🧮 원가관리 종합리포트" endpoint="/ai/analyze/cost" reportType="cost" />}
    </div>
  );
}

// ── 기능1: 업무 지연/문제 분석 (기존 그대로) ──
function TaskDelayPanel() {
  const [analyzing, setAnalyzing] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const run = () => {
    setAnalyzing(true); setError(''); setResult(null);
    API.post('/ai/analyze/tasks').then(r => setResult(r.data)).catch(err => {
      setError(err?.response?.data?.message || 'AI 분석에 실패했습니다.');
    }).finally(() => setAnalyzing(false));
  };

  return (
    <div style={panelStyle}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <h3 style={{ margin: 0, fontSize: 16 }}>📋 업무 지연/문제 분석</h3>
        <button onClick={run} disabled={analyzing} style={btnStyle(analyzing)}>
          {analyzing ? '분석 중... (서버 사양에 따라 최대 몇 분 걸릴 수 있습니다)' : '지금 분석 실행'}
        </button>
      </div>
      {error && <div style={{ color: '#DC2626', fontSize: 13, marginBottom: 10 }}>{error}</div>}
      {result && (
        <div>
          <div style={{ display: 'flex', gap: 10, marginBottom: 14, flexWrap: 'wrap' }}>
            <Badge color="#DC2626" bg="#FEF2F2">마감 지남 {result.stats?.overdueCount ?? 0}건</Badge>
            <Badge color="#B45309" bg="#FFFBEB">3일 이내 임박 {result.stats?.dueSoonCount ?? 0}건</Badge>
            <Badge color="#374151" bg="#F3F4F6">전체 미완료 {result.stats?.totalOpen ?? 0}건</Badge>
          </div>
          <div style={reportBoxStyle}>{result.report}</div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 }}>
            <OnePageReportButton title="업무 지연/문제 분석" content={result.report} />
            <div style={{ fontSize: 11, color: '#9CA3AF' }}>
              생성 시각: {new Date(result.generatedAt).toLocaleString('ko-KR')}
            </div>
          </div>
        </div>
      )}
      {!result && !analyzing && !error && (
        <div style={{ color: '#9CA3AF', fontSize: 13 }}>
          "지금 분석 실행" 버튼을 누르면 마감이 지났거나 3일 이내로 임박한 업무를 모아 AI가 원인과 해결방안을 정리해드립니다.
        </div>
      )}
    </div>
  );
}

function Badge({ children, color, bg }) {
  return <span style={{ background: bg, color, padding: '4px 12px', borderRadius: 16, fontSize: 12, fontWeight: 600 }}>{children}</span>;
}

// ── 경영분석 신규: "1페이지 보고서(가로)" 공용 버튼 ──
// 2026-10 요청: "모든 분석에 대하여 1page 보고서를 작성(가로형) — 3열로 분리해서
// 현재상황/문제점 및 경향/개선방향". 이미 화면에 생성되어 있는 리포트 텍스트(title+content)를
// 백엔드(POST /ai/reports/onepage)로 그대로 넘기면, AI가 3항목으로 재정리해 A4 가로 1페이지
// PDF를 만들어 돌려준다 — 20여 개 분석/리포트 패널이 전부 이 버튼 하나를 재사용한다.
function OnePageReportButton({ title, content, targetLabel, periodLabel }) {
  const [loading, setLoading] = useState(false);
  const run = async () => {
    if (!content || loading) return;
    setLoading(true);
    try {
      const res = await API.post('/ai/reports/onepage', { title, content, targetLabel, periodLabel }, { responseType: 'blob' });
      const blobUrl = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      window.open(blobUrl, '_blank');
    } catch (err) {
      alert('1페이지 보고서 생성 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };
  return (
    <button onClick={run} disabled={loading} style={{
      padding: '6px 12px', borderRadius: 6, border: '1px solid #0D9488', cursor: loading ? 'default' : 'pointer',
      background: loading ? '#F0FDFA' : '#fff', color: '#0D9488', fontSize: 12, fontWeight: 600, flexShrink: 0,
    }}>
      {loading ? '생성 중...' : '🖨 1페이지 보고서(가로)'}
    </button>
  );
}

// ── "현재 자료 분석 반영" — 로컬 지식베이스(등록된 글의 패턴 요약) 갱신 버튼 ──
// 2026-08 요청: 업체관리 OCR에 적용했던 "레퍼런스 학습"과 같은 개념을 AI 어시스턴트 전체로
// 확장. 이 버튼을 누르면 공지사항/업무/영업활동/계약/인증/생산현황/출고/교환반품에 실제
// 등록된 데이터를 훑어(순수 SQL 집계 — AI 호출 없음, 몇 초 내로 끝남) 구분별 빈도, 자주
// 쓰이는 단어, 최근 등록 예시를 뽑아 backend/data/aiKnowledge.json에 저장한다. 이후 챗봇과
// 5개 분석/보고서 기능이 이 요약을 프롬프트에 참고자료로 자동으로 덧붙인다(요청/응답 흐름을
// 바꾸지 않는 순수 보강이라, 버튼을 한 번도 안 눌러도 기존 기능은 그대로 동작한다).
// 2026-08 위치 조정 — 처음엔 화면 상단에 별도 배너로 뒀는데, 실제로 이 요약을 가장 직접
// 활용하는 건 챗봇(대화 컨텍스트로 바로 반영됨)이라 "AI 챗봇" 타이틀 우측으로 옮겼다.
function KnowledgeRefreshButton() {
  const [summary, setSummary] = useState(null);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState('');

  const loadSummary = () => {
    API.get('/ai/knowledge/status').then(r => setSummary(r.data)).catch(() => setSummary(null));
  };
  useEffect(() => { loadSummary(); }, []);

  const run = () => {
    setRefreshing(true); setError('');
    API.post('/ai/knowledge/refresh').then(r => setSummary(r.data)).catch(err => {
      setError(err?.response?.data?.message || '자료 분석에 실패했습니다.');
    }).finally(() => setRefreshing(false));
  };

  const title = '업체관리 OCR에 적용했던 것과 같은 방식으로, 공지사항/업무/영업활동/계약/인증/생산현황/출고/' +
    '교환반품에 실제 등록된 글의 구분별 빈도·자주 쓰이는 단어·최근 등록 예시를 분석해서 챗봇/분석 기능이 참고하도록 반영합니다.';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 3 }}>
      <button onClick={run} disabled={refreshing} title={title} style={{
        padding: '7px 14px', borderRadius: 6, border: 'none', cursor: refreshing ? 'default' : 'pointer',
        background: refreshing ? '#C4B5FD' : '#7C3AED', color: '#fff', fontSize: 12.5, fontWeight: 600, flexShrink: 0,
      }}>
        {refreshing ? '분석 중...' : '📊 지금 자료 분석 반영'}
      </button>
      <span style={{ fontSize: 11, color: error ? '#DC2626' : '#8B5CF6' }}>
        {error || (summary?.generated
          ? `마지막 반영: ${new Date(summary.generatedAt).toLocaleString('ko-KR')}`
          : '아직 반영된 적 없음')}
      </span>
    </div>
  );
}

// 저장된 리포트 PDF를 새 탭으로 연다 — verifyToken 미들웨어 때문에 일반 <a href>로는 인증
// 헤더가 실리지 않아 401이 나므로, 다른 메뉴들(Sales.js 등)과 동일하게 blob으로 받아
// object URL을 만든 뒤 새 창에 띄운다.
async function openReportPdf(id) {
  try {
    const res = await API.get(`/ai/reports/${id}/pdf`, { responseType: 'blob' });
    const blobUrl = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
    window.open(blobUrl, '_blank');
  } catch (err) {
    alert('PDF를 여는 중 오류가 발생했습니다.');
  }
}

// ── 공용: 리포트 목록(ai_reports 저장소 조회) ──
function ReportHistory({ reportType, refreshKey }) {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(null); // 펼쳐서 본문을 보여줄 리포트 id

  useEffect(() => {
    API.get('/ai/reports', { params: { type: reportType, limit: 10 } }).then(r => setRows(r.data)).catch(() => setRows([]));
  }, [reportType, refreshKey]);

  if (!rows.length) return null;
  return (
    <div style={{ marginTop: 18 }}>
      <div style={{ fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 8 }}>지난 리포트</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {rows.map(r => (
          <div key={r.id} style={{ border: '1px solid #eee', borderRadius: 6, padding: '8px 12px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 12, color: '#6B7280' }}>
              <span>
                {new Date(r.created_at).toLocaleString('ko-KR')} · {r.generated_by === 'scheduler' ? '자동생성' : (r.generated_by || '-')}
                {r.target_label ? ` · ${r.target_label}` : ''}
              </span>
              <span>
                <button onClick={() => setOpen(open === r.id ? null : r.id)} style={{ border: 'none', background: 'none', color: '#2563EB', cursor: 'pointer', marginRight: 10 }}>
                  {open === r.id ? '접기' : '보기'}
                </button>
                {r.pdf_path && (
                  <button onClick={() => openReportPdf(r.id)} style={{ border: 'none', background: 'none', color: '#059669', cursor: 'pointer' }}>
                    PDF
                  </button>
                )}
              </span>
            </div>
            {open === r.id && <ReportBody id={r.id} />}
          </div>
        ))}
      </div>
    </div>
  );
}
function ReportBody({ id }) {
  const [content, setContent] = useState('불러오는 중...');
  useEffect(() => {
    API.get(`/ai/reports/${id}`).then(r => setContent(r.data.content)).catch(() => setContent('불러오지 못했습니다.'));
  }, [id]);
  return <div style={{ ...reportBoxStyle, marginTop: 8 }}>{content}</div>;
}

// ── 기능2: 주간회의 종합 리포트 ──
function WeeklyReportPanel() {
  const [generating, setGenerating] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [refreshKey, setRefreshKey] = useState(0);

  const run = () => {
    setGenerating(true); setError(''); setResult(null);
    API.post('/ai/reports/weekly/generate').then(r => { setResult(r.data); setRefreshKey(k => k + 1); }).catch(err => {
      setError(err?.response?.data?.message || 'AI 리포트 생성에 실패했습니다.');
    }).finally(() => setGenerating(false));
  };

  return (
    <div style={panelStyle}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <h3 style={{ margin: 0, fontSize: 16 }}>🗓 주간회의 종합 리포트</h3>
        <button onClick={run} disabled={generating} style={btnStyle(generating)}>
          {generating ? '생성 중...' : '지금 생성'}
        </button>
      </div>
      <div style={{ color: '#9CA3AF', fontSize: 13, marginBottom: 12 }}>
        매주 월요일 오전 8시에 자동으로도 생성됩니다. 완료/진행중/지연/문제(출고·생산) 현황을 종합해 주간회의에 바로 활용할 수 있는 리포트를 만듭니다.
      </div>
      {error && <div style={{ color: '#DC2626', fontSize: 13, marginBottom: 10 }}>{error}</div>}
      {result && (
        <div>
          <div style={{ display: 'flex', gap: 10, marginBottom: 14, flexWrap: 'wrap' }}>
            <Badge color="#059669" bg="#ECFDF5">완료 {result.stats?.doneCount ?? 0}건</Badge>
            <Badge color="#374151" bg="#F3F4F6">진행중 {result.stats?.inProgressCount ?? 0}건</Badge>
            <Badge color="#DC2626" bg="#FEF2F2">지연 {result.stats?.overdueCount ?? 0}건</Badge>
            <Badge color="#B45309" bg="#FFFBEB">문제(출고/생산) {result.stats?.problemCount ?? 0}건</Badge>
          </div>
          <div style={reportBoxStyle}>{result.content}</div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 }}>
            <OnePageReportButton title="주간회의 종합 리포트" content={result.content} />
            {result.pdfPath && <div style={{ fontSize: 11, color: '#9CA3AF' }}>PDF로도 저장되었습니다.</div>}
          </div>
        </div>
      )}
      <ReportHistory reportType="weekly" refreshKey={refreshKey} />
    </div>
  );
}

// ── 기능3: OCR 자동입력 ──
function OcrPanel() {
  const [file, setFile] = useState(null);
  const [needsHanja, setNeedsHanja] = useState(false);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const fileRef = useRef(null);

  const run = () => {
    if (!file) return;
    setLoading(true); setError(''); setResult(null);
    const fd = new FormData();
    fd.append('file', file);
    fd.append('needsHanja', needsHanja ? 'true' : 'false');
    API.post('/ai/ocr', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then(r => setResult(r.data))
      .catch(err => setError(err?.response?.data?.message || 'OCR 처리에 실패했습니다.'))
      .finally(() => setLoading(false));
  };

  const copyText = (text) => {
    if (navigator.clipboard) navigator.clipboard.writeText(text).catch(() => {});
  };

  return (
    <div style={panelStyle}>
      <h3 style={{ margin: '0 0 12px', fontSize: 16 }}>🖼 OCR 자동입력</h3>
      <div style={{ color: '#9CA3AF', fontSize: 13, marginBottom: 12 }}>
        이미지 또는 PDF를 업로드하면 완전 로컬 OCR(한글/영문, 필요시 한자)로 텍스트를 인식하고, AI가 "라벨: 값"
        형태로 정리해드립니다. 정리된 텍스트를 복사해서 원하는 입력폼에 붙여넣어 사용하세요.
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12, flexWrap: 'wrap' }}>
        <input ref={fileRef} type="file" accept="image/*,.pdf" onChange={e => setFile(e.target.files?.[0] || null)} />
        <label style={{ fontSize: 12, color: '#6B7280', display: 'flex', alignItems: 'center', gap: 4 }}>
          <input type="checkbox" checked={needsHanja} onChange={e => setNeedsHanja(e.target.checked)} />
          한자 포함 문서(느려짐)
        </label>
        <button onClick={run} disabled={!file || loading} style={btnStyle(!file || loading)}>
          {loading ? '인식 중...' : '인식 실행'}
        </button>
      </div>
      {error && <div style={{ color: '#DC2626', fontSize: 13, marginBottom: 10 }}>{error}</div>}
      {result && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {result.structuredText && (
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                <div style={{ fontSize: 13, fontWeight: 600 }}>AI 정리 결과</div>
                <button onClick={() => copyText(result.structuredText)} style={{ fontSize: 12, color: '#2563EB', border: 'none', background: 'none', cursor: 'pointer' }}>복사</button>
              </div>
              <div style={reportBoxStyle}>{result.structuredText}</div>
            </div>
          )}
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: '#6B7280' }}>OCR 원문</div>
              <button onClick={() => copyText(result.rawText)} style={{ fontSize: 12, color: '#2563EB', border: 'none', background: 'none', cursor: 'pointer' }}>복사</button>
            </div>
            <div style={{ ...reportBoxStyle, color: '#6B7280', fontSize: 12, maxHeight: 200, overflowY: 'auto' }}>{result.rawText || '(인식된 텍스트가 없습니다)'}</div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── 기능4/8: 직원평가 / 업무난이도평가 (같은 데이터, focus만 다름) ──
function EmployeePanel({ focus, title }) {
  const [users, setUsers] = useState([]);
  const [userId, setUserId] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => { API.get('/ai/users').then(r => setUsers(r.data)).catch(() => setUsers([])); }, []);

  const run = () => {
    if (!userId) return;
    setLoading(true); setError(''); setResult(null);
    API.post('/ai/analyze/employee', { userId, focus }).then(r => { setResult(r.data); setRefreshKey(k => k + 1); }).catch(err => {
      setError(err?.response?.data?.message || 'AI 분석에 실패했습니다.');
    }).finally(() => setLoading(false));
  };

  return (
    <div style={panelStyle}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, gap: 10, flexWrap: 'wrap' }}>
        <h3 style={{ margin: 0, fontSize: 16 }}>{title}</h3>
        <div style={{ display: 'flex', gap: 8 }}>
          <select value={userId} onChange={e => setUserId(e.target.value)} style={{ padding: '7px 10px', borderRadius: 6, border: '1px solid #d1d5db', fontSize: 13 }}>
            <option value="">대상 직원 선택</option>
            {users.map(u => <option key={u.id} value={u.id}>{u.department ? `${u.department} · ` : ''}{u.name}</option>)}
          </select>
          <button onClick={run} disabled={!userId || loading} style={btnStyle(!userId || loading)}>
            {loading ? '분석 중...' : '분석 실행'}
          </button>
        </div>
      </div>
      {error && <div style={{ color: '#DC2626', fontSize: 13, marginBottom: 10 }}>{error}</div>}
      {result && (
        <div>
          <div style={{ display: 'flex', gap: 10, marginBottom: 14, flexWrap: 'wrap' }}>
            <Badge color="#374151" bg="#F3F4F6">담당업무 {result.stats?.taskCount ?? 0}건</Badge>
            <Badge color="#059669" bg="#ECFDF5">완료 {result.stats?.doneCount ?? 0}건</Badge>
            <Badge color="#DC2626" bg="#FEF2F2">마감초과 {result.stats?.overdueCount ?? 0}건</Badge>
            <Badge color="#B45309" bg="#FFFBEB">지각/조퇴/결근 {result.stats?.lateOrAbsent ?? 0}건</Badge>
          </div>
          <div style={reportBoxStyle}>{result.content}</div>
          <div style={{ marginTop: 8 }}>
            <OnePageReportButton title={title} content={result.content} targetLabel={users.find(u => String(u.id) === String(userId))?.name} />
          </div>
        </div>
      )}
      <ReportHistory reportType={`employee_${focus === 'evaluation' ? 'eval' : focus}`} refreshKey={refreshKey} />
    </div>
  );
}

// ── 경영분석 신규: 부서 종합평가 (직원평가와 같은 패턴, 대상만 부서 단위) ──
function DepartmentPanel({ title }) {
  const [departments, setDepartments] = useState([]);
  const [department, setDepartment] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => { API.get('/ai/departments').then(r => setDepartments(r.data)).catch(() => setDepartments([])); }, []);

  const run = () => {
    if (!department) return;
    setLoading(true); setError(''); setResult(null);
    API.post('/ai/analyze/department', { department }).then(r => { setResult(r.data); setRefreshKey(k => k + 1); }).catch(err => {
      setError(err?.response?.data?.message || 'AI 분석에 실패했습니다.');
    }).finally(() => setLoading(false));
  };

  return (
    <div style={panelStyle}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, gap: 10, flexWrap: 'wrap' }}>
        <h3 style={{ margin: 0, fontSize: 16 }}>{title}</h3>
        <div style={{ display: 'flex', gap: 8 }}>
          <select value={department} onChange={e => setDepartment(e.target.value)} style={{ padding: '7px 10px', borderRadius: 6, border: '1px solid #d1d5db', fontSize: 13 }}>
            <option value="">대상 부서 선택</option>
            {departments.map(d => <option key={d} value={d}>{d}</option>)}
          </select>
          <button onClick={run} disabled={!department || loading} style={btnStyle(!department || loading)}>
            {loading ? '분석 중...' : '분석 실행'}
          </button>
        </div>
      </div>
      {error && <div style={{ color: '#DC2626', fontSize: 13, marginBottom: 10 }}>{error}</div>}
      {result && (
        <div>
          <div style={{ display: 'flex', gap: 10, marginBottom: 14, flexWrap: 'wrap' }}>
            <Badge color="#374151" bg="#F3F4F6">소속인원 {result.stats?.memberCount ?? 0}명</Badge>
            <Badge color="#374151" bg="#F3F4F6">담당업무 {result.stats?.taskCount ?? 0}건</Badge>
            <Badge color="#059669" bg="#ECFDF5">완료 {result.stats?.doneCount ?? 0}건</Badge>
            <Badge color="#DC2626" bg="#FEF2F2">마감초과 {result.stats?.overdueCount ?? 0}건</Badge>
            <Badge color="#B45309" bg="#FFFBEB">지각/조퇴/결근 {result.stats?.lateOrAbsent ?? 0}건</Badge>
          </div>
          <div style={reportBoxStyle}>{result.content}</div>
          <div style={{ marginTop: 8 }}>
            <OnePageReportButton title={title} content={result.content} targetLabel={department} />
          </div>
        </div>
      )}
      <ReportHistory reportType="department_eval" refreshKey={refreshKey} />
    </div>
  );
}

// ── 기능5/6: 영업활동 분석 / 종합 보고서 (같은 데이터, focus만 다름) ──
function SalesPanel({ focus, title }) {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [refreshKey, setRefreshKey] = useState(0);

  const run = () => {
    setLoading(true); setError(''); setResult(null);
    API.post('/ai/analyze/sales', { focus }).then(r => { setResult(r.data); setRefreshKey(k => k + 1); }).catch(err => {
      setError(err?.response?.data?.message || 'AI 분석에 실패했습니다.');
    }).finally(() => setLoading(false));
  };

  return (
    <div style={panelStyle}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <h3 style={{ margin: 0, fontSize: 16 }}>{title}</h3>
        <button onClick={run} disabled={loading} style={btnStyle(loading)}>{loading ? '분석 중...' : '지금 분석 실행'}</button>
      </div>
      {error && <div style={{ color: '#DC2626', fontSize: 13, marginBottom: 10 }}>{error}</div>}
      {result && (
        <div>
          <div style={{ display: 'flex', gap: 10, marginBottom: 14, flexWrap: 'wrap' }}>
            <Badge color="#374151" bg="#F3F4F6">최근60일 {result.stats?.total ?? 0}건</Badge>
            <Badge color="#059669" bg="#ECFDF5">완료 {result.stats?.completed ?? 0}건</Badge>
            <Badge color="#B45309" bg="#FFFBEB">진행중 {result.stats?.inProgress ?? 0}건</Badge>
            <Badge color="#2563EB" bg="#EFF6FF">완료율 {result.stats?.rate ?? 0}%</Badge>
          </div>
          <div style={reportBoxStyle}>{result.content}</div>
          <div style={{ marginTop: 8 }}>
            <OnePageReportButton title={title} content={result.content} />
          </div>
        </div>
      )}
      <ReportHistory reportType={focus === 'report' ? 'sales_report' : 'sales_problem'} refreshKey={refreshKey} />
    </div>
  );
}

// ── 기능7/9/10: 파라미터 없이 바로 실행하는 리포트형 기능 공용 패널 ──
function SimpleReportPanel({ title, endpoint, reportType, body }) {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [refreshKey, setRefreshKey] = useState(0);

  const run = () => {
    setLoading(true); setError(''); setResult(null);
    API.post(endpoint, body || {}).then(r => { setResult(r.data); setRefreshKey(k => k + 1); }).catch(err => {
      setError(err?.response?.data?.message || 'AI 분석에 실패했습니다.');
    }).finally(() => setLoading(false));
  };

  return (
    <div style={panelStyle}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <h3 style={{ margin: 0, fontSize: 16 }}>{title}</h3>
        <button onClick={run} disabled={loading} style={btnStyle(loading)}>{loading ? '분석 중...' : '지금 분석 실행'}</button>
      </div>
      {error && <div style={{ color: '#DC2626', fontSize: 13, marginBottom: 10 }}>{error}</div>}
      {result && (
        <div>
          <div style={reportBoxStyle}>{result.content}</div>
          <div style={{ marginTop: 8 }}>
            <OnePageReportButton title={title} content={result.content} />
          </div>
        </div>
      )}
      <ReportHistory reportType={reportType} refreshKey={refreshKey} />
    </div>
  );
}

// ── 기능11: AI 챗봇 ──
function ChatPanel() {
  const [messages, setMessages] = useState([]); // {role:'user'|'assistant', content}
  const [input, setInput] = useState('');
  const [sending, setSending] = useState(false);
  const bottomRef = useRef(null);

  useEffect(() => { bottomRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [messages]);

  const send = () => {
    const text = input.trim();
    if (!text || sending) return;
    const nextMessages = [...messages, { role: 'user', content: text }];
    setMessages(nextMessages);
    setInput('');
    setSending(true);
    API.post('/ai/chat', { message: text, history: messages.slice(-6) })
      .then(r => setMessages(m => [...m, { role: 'assistant', content: r.data.reply }]))
      .catch(err => setMessages(m => [...m, { role: 'assistant', content: '⚠ ' + (err?.response?.data?.message || 'AI 응답에 실패했습니다.') }]))
      .finally(() => setSending(false));
  };

  return (
    <div style={panelStyle}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12, gap: 10, flexWrap: 'wrap' }}>
        <h3 style={{ margin: 0, fontSize: 16 }}>💬 AI 챗봇</h3>
        <KnowledgeRefreshButton />
      </div>
      <div style={{ color: '#9CA3AF', fontSize: 13, marginBottom: 12 }}>
        간단한 질문에 답하거나, 미완료 업무/영업활동/인증만료 등 IMS 요약 정보를 참고해 답변합니다. 새로고침하면 대화가 초기화됩니다.
      </div>
      <div style={{ border: '1px solid #eee', borderRadius: 8, background: '#F9FAFB', height: 340, overflowY: 'auto', padding: 14, marginBottom: 12 }}>
        {messages.length === 0 && <div style={{ color: '#9CA3AF', fontSize: 13 }}>궁금한 것을 물어보세요. 예: "이번주 마감 지난 업무 몇 건이야?"</div>}
        {messages.map((m, i) => (
          <div key={i} style={{ display: 'flex', justifyContent: m.role === 'user' ? 'flex-end' : 'flex-start', marginBottom: 10 }}>
            <div style={{
              maxWidth: '75%', padding: '9px 13px', borderRadius: 10, fontSize: 14, lineHeight: 1.6, whiteSpace: 'pre-wrap',
              background: m.role === 'user' ? '#2563EB' : '#fff', color: m.role === 'user' ? '#fff' : '#1f2937',
              border: m.role === 'user' ? 'none' : '1px solid #eee',
            }}>{m.content}</div>
          </div>
        ))}
        {sending && <div style={{ color: '#9CA3AF', fontSize: 13 }}>AI가 답변을 작성 중...</div>}
        <div ref={bottomRef} />
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <input
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') send(); }}
          placeholder="질문을 입력하세요"
          style={{ flex: 1, padding: '10px 12px', borderRadius: 6, border: '1px solid #d1d5db', fontSize: 14 }}
        />
        <button onClick={send} disabled={!input.trim() || sending} style={btnStyle(!input.trim() || sending)}>전송</button>
      </div>
    </div>
  );
}
